/**
 * 奖励&成就页面-成奖励tab内容
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import classnames from 'classnames';
import './Reward.scss';

const RewardBox = (props: any) => {
  return (
    <div className={classnames('rewardBox')}>
      <div className='bg'>
        <div
          className={classnames('rewardBox-top', props.medal && 'medal')}
        ></div>
        <div
          className={classnames('rewardBox-mid', props.medal && 'medal')}
        ></div>
        <div
          className={classnames('rewardBox-btm', props.medal && 'medal')}
        ></div>
      </div>
      {props.children}
    </div>
  );
};

const RewardTab = (props: any) => {
  return (
    <div className='rewardTab'>
      <div className='rewardTab-title'>游戏道具奖励</div>
      {/* 新手题库礼包 */}
      {props.rewardList?.map((item: any, index: number) => {
        return (
          <div key={index}>
            <RewardBox key={index}>
              <div className='rewardTab-content' key={'reward' + index}>
                <div
                  className={classnames(
                    'rewardTab-content-title',
                    'title' + Number(index + 1)
                  )}
                ></div>
                <div className='rewardTab-content-rewards'>
                  {item.list?.map((iitem: any, iindex: number) => {
                    return (
                      <div
                        className='rewardTab-content-reward'
                        key={'reward_list' + iindex}
                      >
                        <div className='reward-mask-wrap'>
                          <img src={iitem.img} alt='' />
                          <div className='reward-mask'></div>
                        </div>

                        <div className='rewardTab-content-reward__title'>
                          {iitem.title}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className='rewardTab-content-desc'>{item.title}</div>
                {/* btn-got 已领取 */}
                <div
                  className={classnames(
                    'rewardTab-content-btn',
                    item.status == 1 && 'btn-got'
                  )}
                  onClick={() => props.handleGetReward(item, index)}
                >
                  领取
                </div>
              </div>
            </RewardBox>
          </div>
        );
      })}
      <div className='rewardTab-title2'>勋章奖励</div>
      <img
        className='rewardTab-content2'
        src={require('../../../assets/img/reward-content2.png')}
        alt='\'
      />
    </div>
  );
};

export default RewardTab;
